import './index.scss';
import "core-js/stable";

import { ModulesLoader } from "./scripts/modulesLoader";
import { Accordion } from "./scripts/modules/accordion";
import { MainNavigation } from "./scripts/modules/main-navigation";
import { Modal } from "./scripts/modules/modal";

export const modulesLoader = new ModulesLoader([
  {
    className: "Accordion",
    classModule: Accordion,
    domTarget: "[data-module-accordion]",
  },
  {
    className: "MainNavigation",
    classModule: MainNavigation,
    domTarget: "[data-module-main-navigation]",
  },
  {
    className: "Modal",
    classModule: Modal,
    domTarget: "[data-module-modal]",
  },
]);

document.moduleLoaders = modulesLoader;

document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(function (mutationsList) {
    for (let mutation of mutationsList) {
      new Promise((resolve) => {
        modulesLoader.loadModules(mutation.target);
        resolve();
      }).then(() => {
        if (process.env.NODE_ENV !== "production") {
          console.info("Mutation occured", mutation);
        }
      });
    }
  });

  observer.observe(document.body, {
    attributes: false,
    childList: true,
    subtree: true,
  });

  modulesLoader.loadModules(document);
});


window.onscroll = function() {
  (window.pageYOffset >= 1) ?
    document.body.classList.add('sticky-header') :
    document.body.classList.remove('sticky-header');
};
